const EDIT_APP_SEASON_DRAFT_PREFIX = 'admin:appSeasonDraft:edit:'
export const NEW_APP_SEASON_DRAFT_KEY = 'admin:appSeasonDraft:new'
export const APP_SEASON_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_SEASON_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'

// App 시즌 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isAppSeasonImageFile = (file) => {
    return Boolean(file) && (
        (file.type && file.type.startsWith('image/')) ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
    )
}

const APP_SEASON_PARAM_FIELDS = [
    'noticeId',
    'title',
    'content',
    'startTime',
    'endTime',
    'meetType',
    'menuType',
    'menuTitle',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// App 시즌 폼에서 다시 입력 비용이 큰 값만 sessionStorage에 남긴다.
export const createAppSeasonDraftPayload = ({ params = {}, noticePage = 1 }) => {
    return {
        params: {
            noticeId: params.noticeId ?? '',
            title: params.title || '',
            content: params.content || '',
            startTime: serializeDateValue(params.startTime),
            endTime: serializeDateValue(params.endTime),
            meetType: params.meetType ?? 3,
            menuType: params.menuType ?? 2,
            menuTitle: params.menuTitle || '',
        },
        noticePage,
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppSeasonDraft = ({ baseParams = {}, baseNoticePage = 1, draft }) => {
    if (!draft) {
        return {
            params: baseParams,
            noticePage: baseNoticePage,
        }
    }

    const draftParams = draft.params || {}
    const nextParams = {
        ...baseParams,
    }

    APP_SEASON_PARAM_FIELDS.forEach((field) => {
        if (draftParams[field] === undefined) {
            return
        }

        if (field === 'startTime' || field === 'endTime') {
            nextParams[field] = parseDateValue(draftParams[field], baseParams[field] ?? null)
            return
        }

        nextParams[field] = draftParams[field]
    })

    return {
        params: nextParams,
        noticePage: parseNumberValue(draft.noticePage, baseNoticePage),
    }
}

export const createEditAppSeasonDraftKey = (seasonId) => `${EDIT_APP_SEASON_DRAFT_PREFIX}${seasonId}`

export const readAppSeasonDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppSeasonDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppSeasonDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
